import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';

const apiHosts = [environment.securityApiUrl, environment.portalApiUrl, environment.companyApiUrl, environment.bankApiUrl];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const isApiRequest = apiHosts.some((host) => req.url.startsWith(host));
  const isRefresh = req.url.includes('/api/auth/session/refresh');
  const token = auth.getToken();
  const authorizedRequest = isApiRequest && !isRefresh && token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authorizedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || !isApiRequest || isRefresh || req.url.includes('/api/auth/')) return throwError(() => error);
      return auth.refresh().pipe(switchMap(() => next(req.clone({ setHeaders: { Authorization: `Bearer ${auth.getToken()}` } }))), catchError((refreshError) => throwError(() => refreshError)));
    })
  );
};
